import React, { useState } from 'react'

import { useRouter } from 'next/router'

import { ArrowForward, MarkEmailReadOutlined, Replay } from '@mui/icons-material'
import { Box, Button, Container, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import Modal from '@mui/material/Modal'
import { useAuth0 } from 'shim/auth0-react'

export default function VerificationErrorOverlay() {
  const { logout } = useAuth0()
  const [showProgress, setShowProgress] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [error, setError] = useState('')
  const router = useRouter()

  const handleResendClick = async () => {
    setShowProgress(true)
    const res = await fetch('/console-api/verification/send', {
      method: 'POST',
    })
    if (res.ok) {
      setShowProgress(false)
      setEmailSent(true)
    } else {
      setShowProgress(false)
      setError('Error sending verification email. Please try again or reach out to support.')
    }
  }

  return (
    <>
      <Modal BackdropProps={{ open: false }} open={true}>
        <>
          <Container maxWidth="xl">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100vh',
                width: '100%',
              }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <h1 style={{ lineHeight: 1.5 + 'em' }}>Please verify your email before proceeding further</h1>
              </Box>
              <Box sx={{ height: '100px', textAlign: 'center' }}>
                <Button
                  onClick={handleResendClick}
                  size="large"
                  color="secondary"
                  variant="contained"
                  sx={{ mr: '6px', textTransform: 'none', marginLeft: 'auto', minWidth: '160px' }}
                  endIcon={
                    showProgress ? (
                      <CircularProgress size={18} sx={{ color: 'white' }} />
                    ) : emailSent ? (
                      <MarkEmailReadOutlined />
                    ) : (
                      <Replay />
                    )
                  }
                >
                  {emailSent ? 'Verification Email Sent' : 'Re-send Verification Email'}
                </Button>
                {error && <Typography sx={{ color: 'red', mt: '10px' }}>{error}</Typography>}
              </Box>
              <Box sx={{ height: '50px', mt: '100px' }}>
                <Button
                  onClick={() => {
                    router.reload()
                  }}
                  color="primary"
                  variant="contained"
                  size="medium"
                  sx={{ mr: '6px', textTransform: 'none', marginLeft: 'auto', minWidth: '160px' }}
                  endIcon={<ArrowForward />}
                >
                  Email Verified
                </Button>
              </Box>
              <div>
                <a href="https://support.section.io/hc/en-us" target="_blank" rel="noreferrer">
                  <h5>Please contact support for more assistance.</h5>
                </a>
              </div>

              <Button
                color="primary"
                onClick={() => {
                  logout({
                    returnTo: typeof window !== 'undefined' ? window.location.origin : '',
                  })
                }}
              >
                Log Out
              </Button>
            </Box>
          </Container>
        </>
      </Modal>
    </>
  )
}
